'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _commonFormsy = require('../common-formsy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PasswordResetForm = (_temp = _class = function (_Component) {
  _inherits(PasswordResetForm, _Component);

  function PasswordResetForm() {
    _classCallCheck(this, PasswordResetForm);

    return _possibleConstructorReturn(this, (PasswordResetForm.__proto__ || Object.getPrototypeOf(PasswordResetForm)).apply(this, arguments));
  }

  _createClass(PasswordResetForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          errorMessages = _props.errorMessages,
          isSubmitting = _props.isSubmitting,
          onFormSubmit = _props.onFormSubmit,
          token = _props.token,
          uid = _props.uid;


      return _react2.default.createElement(
        _commonFormsy.Form,
        { onValidSubmit: onFormSubmit },
        _react2.default.createElement(_commonFormsy.Input, { type: 'hidden', name: 'uid', value: uid }),
        _react2.default.createElement(_commonFormsy.Input, { type: 'hidden', name: 'token', value: token }),
        _react2.default.createElement(_commonFormsy.Input, {
          name: 'new_password',
          label: 'New Password',
          type: 'password',
          validateOnBlur: false,
          required: true
        }),
        _react2.default.createElement(_commonFormsy.Input, {
          name: 're_new_password',
          label: 'Confirm Password',
          type: 'password',
          validateOnBlur: false,
          required: true
        }),
        _react2.default.createElement(
          _Button2.default,
          { bsStyle: 'primary', disabled: isSubmitting, type: 'submit' },
          'Set new password'
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-red' },
          errorMessages.map(function (error, idx) {
            return _react2.default.createElement(
              'p',
              { key: idx },
              error
            );
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PasswordResetForm;
}(_react.Component), _class.propTypes = {
  errorMessages: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  isSubmitting: _propTypes2.default.bool.isRequired,
  onFormSubmit: _propTypes2.default.func.isRequired,
  token: _propTypes2.default.string.isRequired,
  uid: _propTypes2.default.string.isRequired
}, _temp);
var _default = PasswordResetForm;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PasswordResetForm, 'PasswordResetForm', '/app/src/components/page-password-reset/PasswordResetForm.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-password-reset/PasswordResetForm.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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